
import UpdateBank from "components/ManageBank/UpdateBank";
import NotFooterLayout from "layouts/NotFooterLayout";
import { useParams } from "react-router-dom";
 

function UpdateBankPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <NotFooterLayout namePage="เพิ่มบัญชี" >
      <div className="layout-content">
        <UpdateBank id={id ?? ''} />
      </div>
    </NotFooterLayout>
  );
}

export default UpdateBankPage;